import React from "react";
import MainLayout from "../../common/MainLayout";
import { Box, CssBaseline } from "@mui/material";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";

const Logout = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header mainTitle={"Logout"} />
      <Sidebar />
      <MainLayout>
        <h1>Logout</h1>
      </MainLayout>
    </Box>
  );
};

export default Logout;
